export const HARDCODED_DATE = new Date("2025-09-30");
